  if (!customElements.get('alb-info-panel')) {
    customElements.define('alb-info-panel', class extends HTMLElement {
      connectedCallback(){
        // Custom-Element kann VOR seinen Kindern upgegradet werden (2.+ Instanz,
        // wenn die Klasse durch die 1. Instanz bereits definiert ist). Daher Setup
        // aufschieben, bis der Drawer im DOM ist.
        var self = this;
        if (this._init) return;
        var start = function(){
          if (self._init || !self.querySelector('.alb-ip-drawer')) return;
          self._init = true; self.setup();
        };
        if (this.querySelector('.alb-ip-drawer')) { this._init = true; this.setup(); }
        else if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
        else { requestAnimationFrame(start); }
      }
      setup(){
        var self = this;
        this.sectionId = this.getAttribute('data-section-id');
        this.option    = (this.getAttribute('data-info-option') || '').trim();
        this.trigLabel = this.getAttribute('data-trigger-label') || 'Mehr erfahren';
        this.backdrop  = this.querySelector('[data-info-backdrop]');
        this.drawer    = this.querySelector('.alb-ip-drawer');

        this.querySelectorAll('[data-info-close]').forEach(function(b){ b.addEventListener('click', function(){ self.close(); }); });
        // CTA-Blocks: Optionswert in der PDP-Variantenauswahl setzen + Panel schließen
        this.querySelectorAll('[data-ip-select]').forEach(function(b){
          b.addEventListener('click', function(){ self.choose(b.getAttribute('data-ip-select') || ''); });
        });
        if (this.backdrop) this.backdrop.addEventListener('click', function(){ self.close(); });
        this._onKey = function(e){ if (e.key === 'Escape') self.close(); };
        document.addEventListener('keydown', this._onKey);

        this.injectTrigger();

        document.addEventListener('shopify:section:select', function(e){ if (e.detail && e.detail.sectionId === self.sectionId) self.open(); });
        document.addEventListener('shopify:section:deselect', function(e){ if (e.detail && e.detail.sectionId === self.sectionId) self.close(); });
      }
      disconnectedCallback(){
        document.removeEventListener('keydown', this._onKey);
        if (this._trigger && this._trigger.parentNode) this._trigger.parentNode.removeChild(this._trigger);
      }
      injectTrigger(){
        if (!this.option) return;
        var self = this, key = this.option.toLowerCase(), target = null;
        document.querySelectorAll('.alb-mp-opt-label[data-opt-name]').forEach(function(l){
          if ((l.getAttribute('data-opt-name') || '').trim().toLowerCase() === key) target = l;
        });
        if (!target || target.querySelector('.alb-mp-info')) return;
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'alb-mp-info'; btn.setAttribute('aria-haspopup', 'dialog');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11.5v4.5"/><circle cx="12" cy="7.6" r=".9" fill="currentColor" stroke="none"/></svg>';
        var span = document.createElement('span'); span.textContent = this.trigLabel; btn.appendChild(span);
        btn.addEventListener('click', function(e){ e.preventDefault(); self.open(); });
        target.appendChild(btn);
        this._trigger = btn;
      }
      // Options-Gruppe (.alb-mp-opt) der PDP, deren Label zum Panel-Setting 'option' passt
      optGroup(){
        var key = (this.option || '').trim().toLowerCase(), group = null;
        document.querySelectorAll('.alb-mp-opt-label[data-opt-name]').forEach(function(l){
          if ((l.getAttribute('data-opt-name') || '').trim().toLowerCase() === key) group = l.closest('.alb-mp-opt');
        });
        return group;
      }
      // CTA: gewuenschten Optionswert anhaken (loest das change-Event der Variantenauswahl aus) + schliessen
      choose(val){
        var want = (val || '').trim().toLowerCase(), group = this.optGroup();
        if (group){
          group.querySelectorAll('input[data-opt-input]').forEach(function(inp){
            if (inp.value.trim().toLowerCase() === want && !inp.checked){
              inp.checked = true;
              inp.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
        this.close();
      }
      // Preisdifferenz (in Cent) des Zielwerts zur guenstigsten anderen Auspraegung dieser
      // Option — bezogen auf die aktuell gewaehlten uebrigen Optionen (Aufpreis haengt
      // z. B. bei den Mobil-Filtern von der Farbe ab). null = nicht ermittelbar/kein Aufpreis.
      priceDiff(targetVal){
        try {
          var group = this.optGroup(); if (!group) return null;
          var first = group.querySelector('input[data-opt-input]'); if (!first) return null;
          var idx = parseInt(first.getAttribute('data-opt-input'), 10);
          var picker = group.closest('alb-variant-picker'); if (!picker) return null;
          var data = picker.querySelector('script[data-variants]'); if (!data) return null;
          var variants = JSON.parse(data.textContent);
          var chosen = [];
          picker.querySelectorAll('.alb-mp-opt').forEach(function(opt, i){
            var c = opt.querySelector('input[data-opt-input]:checked');
            chosen[i] = c ? c.value : null;
          });
          var priceFor = function(valLower){
            var m = variants.find(function(v){
              return v.options.every(function(o, i){
                if (i === idx) return String(o).trim().toLowerCase() === valLower;
                return chosen[i] == null || String(o) === chosen[i];
              });
            });
            if (!m) return null;
            var p = m.price;
            return (typeof p === 'number') ? p : Math.round(parseFloat(String(p).replace(',', '.')) * 100);
          };
          var want = (targetVal || '').trim().toLowerCase();
          var target = priceFor(want); if (target === null) return null;
          var base = null;
          group.querySelectorAll('input[data-opt-input]').forEach(function(inp){
            var v = inp.value.trim().toLowerCase();
            if (v === want) return;
            var p = priceFor(v);
            if (p !== null && (base === null || p < base)) base = p;
          });
          if (base === null) return null;
          var d = target - base;
          return d > 0 ? d : null;
        } catch (e){ return null; }
      }
      // {aufpreis}-Platzhalter in CTA-Zusatzzeilen fuellen (bei jedem Oeffnen neu,
      // die Auswahl der uebrigen Optionen kann sich zwischendurch geaendert haben)
      fillDiffs(){
        var self = this;
        this.querySelectorAll('[data-ip-sub]').forEach(function(el){
          var tpl = el.getAttribute('data-ip-sub') || '';
          if (tpl.indexOf('{aufpreis}') === -1) return;
          var btn = el.closest('[data-ip-select]');
          var d = self.priceDiff(btn ? btn.getAttribute('data-ip-select') : '');
          if (d === null){ el.hidden = true; return; }
          var txt = (d / 100).toFixed(2).replace('.', ',') + ' €';
          el.textContent = tpl.replace('{aufpreis}', txt);
          el.hidden = false;
        });
      }
      open(){
        var d = this.drawer; if (!d) return;
        this.fillDiffs();
        this.markSelects();
        if (this.backdrop){ this.backdrop.hidden = false; var bd = this.backdrop; requestAnimationFrame(function(){ bd.classList.add('is-open'); }); }
        d.hidden = false; d.setAttribute('aria-hidden', 'false');
        void d.offsetWidth;
        d.classList.add('is-open');
        document.documentElement.classList.add('alb-ip-noscroll');
        // Autoplay-Videos erst jetzt starten (stumm; prefers-reduced-motion respektieren)
        if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          d.querySelectorAll('.alb-ip-video--auto video').forEach(function(v){
            v.muted = true;
            var p = v.play(); if (p && p.catch) p.catch(function(){});
          });
        }
        var c = d.querySelector('[data-info-close]'); if (c) c.focus();
      }
      // Auswählen-Buttons der Feature-Zeilen: aktuell gewählten Wert als „Ausgewählt" markieren,
      // Buttons für Werte, die das Produkt nicht hat, ausblenden (2026-10-05).
      markSelects(){
        var group = this.optGroup();
        var vals = {}, cur = '';
        if (group){
          group.querySelectorAll('input[data-opt-input]').forEach(function(inp){
            var v = inp.value.trim().toLowerCase(); vals[v] = true;
            if (inp.checked) cur = v;
          });
        }
        this.querySelectorAll('.alb-ip-fsel[data-ip-select]').forEach(function(b){
          var v = (b.getAttribute('data-ip-select') || '').trim().toLowerCase();
          var row = b.closest('.alb-ip-feature');
          var exists = !group || !!vals[v];
          if (row) row.hidden = !exists;
          var on = exists && v === cur;
          b.classList.toggle('is-current', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          var lbl = b.querySelector('.alb-ip-fsel-txt');
          if (lbl) lbl.textContent = on ? (b.getAttribute('data-label-current') || 'Ausgewählt') : (b.getAttribute('data-label') || 'Auswählen');
        });
      }
      close(){
        var self = this, d = this.drawer;
        if (this.backdrop) this.backdrop.classList.remove('is-open');
        if (d && d.classList.contains('is-open')){
          d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
          var onEnd = function(){ d.hidden = true; d.removeEventListener('transitionend', onEnd); };
          d.addEventListener('transitionend', onEnd);
        }
        // Alle Videos im Drawer pausieren (auch manuell gestartete)
        if (d) d.querySelectorAll('video').forEach(function(v){ v.pause(); });
        document.documentElement.classList.remove('alb-ip-noscroll');
        if (this.backdrop){ var bd = this.backdrop; setTimeout(function(){ if (!d.classList.contains('is-open')) bd.hidden = true; }, 320); }
      }
    });
  }
